import { ChakraFlex, ChakraText, EquipUITheme } from '@equip.health/ui';
import { DateTime } from 'luxon';

import { getAgeFromDOB } from '~/lib/util/patient.util';

import NotificationAvatar from '../NotificationAvatar';

const TOP_LEVEL_ID = 'notification-user-detail';

interface NotificationUserDetailProps {
  dob?: string;
  patientName?: string;
}

const { label, labelBold } = EquipUITheme.typography;

const NotificationUserDetail = ({
  dob,
  patientName,
}: NotificationUserDetailProps) => {
  const formattedDob = DateTime.fromSQL(dob).toFormat('LL/dd/yyyy');
  const age = getAgeFromDOB(dob, 'yyyy-LL-dd');

  return (
    <ChakraFlex
      backgroundColor="neutral.background.secondary"
      borderRadius="8px"
      id={`${TOP_LEVEL_ID}__wrapper`}
      marginTop="8px"
      padding="8px"
    >
      <NotificationAvatar patientName={patientName} />
      <ChakraFlex direction="column" paddingLeft="18px">
        <ChakraText id={`${TOP_LEVEL_ID}__name`} {...labelBold}>
          {patientName}
        </ChakraText>
        {!!age && (
          <ChakraText id={`${TOP_LEVEL_ID}__dob`} {...label}>
            {`${formattedDob} - ${age} years old`}
          </ChakraText>
        )}
      </ChakraFlex>
    </ChakraFlex>
  );
};

export default NotificationUserDetail;
